import { all }           from 'redux-saga/effects'

import toastSaga from './toast.saga'

export default function * rootSaga () {
  yield all([
    toastSaga(),
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.ts